import { ButtonProps, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components';
import { trans } from '@/i18n';

interface IProps extends ButtonProps {
  name?: string;
  path?: string;
  textColor?: string;
  bgColor?: string;
  onClick?: () => void;
  fontSize?: number;
}

function BtnPrimary({ name, path, ...props }: IProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (path) {
      navigate(path);
      return;
    }
    props.onClick?.();
  };

  return (
    <Button
      minW="100px"
      h="35px"
      onClick={handleClick}
      style={{ background: props?.bgColor || 'linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)' }}
      {...props}
    >
      <Text fontSize={props.fontSize || 14} color={props?.textColor || "#fff"} fontWeight="bold" lineHeight="150%">
        {trans(name || 'shared.addNew')}
      </Text>
    </Button>
  );
}

export { BtnPrimary };
